module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notification"
  }, [_c('div', {
    class: {
      'notification__info-border': _vm.isInfo,
      'notification__success-border': _vm.isSuccess,
      'notification__warning-border': _vm.isWarning,
      'notification__error-border': _vm.isError
    }
  }, [_c('span', [_c('notification-icon', {
    staticClass: "notification__icon",
    attrs: {
      "notification": _vm.notification
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "notification__button"
  }, [_c('icon', {
    attrs: {
      "name": "times-circle",
      "scale": "1.4"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deleteNotification.apply(null, arguments)
      }
    }
  })], 1), _vm._v("\n    " + _vm._s(_vm.notification.description) + "\n  ")]), _vm._v(" "), (_vm.action) ? [_c('div', {
    staticClass: "notification__action-block"
  }, [_c('oval-button', {
    staticClass: "notification__action",
    nativeOn: {
      "click": function($event) {
        return _vm.actionCommand.apply(null, arguments)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.action.title) + "\n      ")])], 1)] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-733a7e70"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/notifications/Notification.vue
// module id = 1952
// module chunks = 0